import { useIntl } from 'react-intl';
import { Outlet, generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import NavigationTabs from '@sorare/core/src/atoms/navigation/NavigationTabs';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  FOOTBALL_CLUB_SHOP,
  FOOTBALL_CLUB_SHOP_TAB,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary, navLabels } from '@sorare/core/src/lib/glossary';
import RequireAuth from '@sorare/core/src/routing/RequireAuth';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import Header from './Header';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--triple-unit);
  flex: 1;
  overflow: hidden;
  background: var(--c-neutral-100);
  @media ${laptopAndAbove} {
    gap: 0;
  }
`;

const TabsWrapper = styled(Container)`
  row-gap: var(--double-unit);
`;

const ClubShopLayout = () => {
  const { formatMessage } = useIntl();

  const tabItems = [
    {
      path: FOOTBALL_CLUB_SHOP,
      label: formatMessage({
        id: 'ClubShop.Tabs.All',
        defaultMessage: 'All',
      }),
    },
    {
      path: generatePath(FOOTBALL_CLUB_SHOP_TAB, { tab: 'skins' }),
      label: formatMessage({
        id: 'ClubShop.Tabs.Skins',
        defaultMessage: 'Skins',
      }),
    },
    {
      path: generatePath(FOOTBALL_CLUB_SHOP_TAB, { tab: 'boosts' }),
      label: formatMessage({
        id: 'ClubShop.Tabs.Boosts',
        defaultMessage: 'Boosts',
      }),
    },
    {
      path: generatePath(FOOTBALL_CLUB_SHOP_TAB, { tab: 'merch' }),
      label: formatMessage({
        id: 'ClubShop.Tabs.Merch',
        defaultMessage: 'Merch',
      }),
    },
    {
      path: generatePath(FOOTBALL_CLUB_SHOP_TAB, { tab: 'inventory' }),
      label: formatMessage(glossary.inventory),
    },
  ].map(({ path, ...rest }) => ({ to: path, path, ...rest }));
  return (
    <RequireAuth>
      <PageHeader text={navLabels.clubshop} />
      <Root>
        <Header />
        <TabsWrapper>
          <NavigationTabs items={tabItems} />
          <Outlet />
        </TabsWrapper>
      </Root>
    </RequireAuth>
  );
};

export default ClubShopLayout;
